<template>
  <el-table-column
    prop="receipt_number"
    sortable="custom"
    label="Bizonylatszám"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <receipt-link
        v-if="scope.row.status !== 'cancelled' && scope.row.receipt_number"
        :id="scope.row.id"
        :label="scope.row.receipt_number"
        type="customerOrder"
      />
    </template>
  </el-table-column>
</template>

<script>
import ReceiptLink from '../../../utils/ReceiptLink';

export default {
  components: {
    ReceiptLink,
  },
  propName: 'receipt_number',
};
</script>
